import { MenuItem } from 'shared';

import { useDeleteGoalFocusArea } from 'features/goal';

type TGoalFocusAreaDeleteButton = {
  focusAreaId: string;
};

export const GoalFocusAreaDeleteButton = ({
  focusAreaId,
}: TGoalFocusAreaDeleteButton) => {
  const { onDeleteFocusAreaClick } = useDeleteGoalFocusArea({ focusAreaId });

  return <MenuItem onClick={onDeleteFocusAreaClick}>Delete</MenuItem>;
};
